import IconTiktok from "@assets/iconUpdate/ttSvg.svg";
import IconBlog from "@assets/iconUpdate/blogSvg.svg";
import IconInstagram from "@assets/iconUpdate/igSvg.svg";
import IconYoutube from "@assets/iconUpdate/ytSvg.svg";

type Platform = "tiktok" | "blog" | "instagram" | "youtube";

type PlatformIconProps = {
  platform: Platform;
  className?: string;
};

const PlatformIcon = ({ platform, className }: PlatformIconProps) => {
  const icons = {
    tiktok: IconTiktok,
    blog: IconBlog,
    instagram: IconInstagram,
    youtube: IconYoutube,
  };

  const Icon = icons[platform];

  if (!Icon) return null;

  return <img src={Icon} alt={platform} className={className} />;
};

export default PlatformIcon;
